import { render } from "./coupon.vue?vue&type=template&id=3a3c63a2&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=3a3c63a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a3c63a2"

export default script